module.exports = __webpack_public_path__ + "img/prexange_apropos_img2.056c8b72.png";